'use client';

import { usePeriod } from '@/app/context/PeriodContext';
import { SharinSingleCollaboratorDetailsResponse } from '@/app/models/sharingDetails';
import {
  useFindSingleCollaboratorAndExpenseProjectQuery,
  useFindSingleCollaboratorProjectQuery,
} from '@/app/services/SharingDetails';
import SharingCollaboratorDetailsTable from '@/components/sharingDetails/SharingCollaboratorDetailsTable';
import SharingCollaboratorExpenseDetail from '@/components/sharingDetails/SharingCollaboratorExpenseDetail';
import SharingCollaboratorTableHeader from '@/components/sharingDetails/SharingCollaboratorTableHeader';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

function SharingCollaboratorDetails() {
  const { code, codeCollaborator } = useParams();

  const { selectedPeriod } = usePeriod();

  const { data: sharingSingleCollaboratorProject } = useFindSingleCollaboratorProjectQuery(
    {
      data: selectedPeriod?.date as string,
      code: (codeCollaborator as string) || '',
      badge: code as string,
    },
    {
      skip: !selectedPeriod?.date,
    },
  );

  const { data: singleCollaboratorAndExpense } = useFindSingleCollaboratorAndExpenseProjectQuery(
    {
      data: selectedPeriod?.date as string,
      badge: codeCollaborator as string,
      code: code || '',
    },
    {
      skip: !selectedPeriod?.date,
    },
  );
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box
        sx={{
          mb: 4,
          mt: 1,
        }}
      >
        <SharingCollaboratorTableHeader
          rows={sharingSingleCollaboratorProject as SharinSingleCollaboratorDetailsResponse}
        />
        <SharingCollaboratorExpenseDetail rows={singleCollaboratorAndExpense || []} />
      </Box>

      <SharingCollaboratorDetailsTable rows={singleCollaboratorAndExpense || []} />
    </Box>
  );
}

export default SharingCollaboratorDetails;
